// This file was extracted from `src/rxdb/syncReplicationStatesWithGraphQL.ts`.
import { BorerOperatorChange } from '../../BorerOperatorChangeFeed/queryBuilder';
import RxdbManager from '../../RxdbManager';
import { PushResponseModifier } from '../replicate';
import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';

export const approvedStatuses = ['processed', 'queued'];
export const pushResponseModifier: PushResponseModifier<BorerOperatorChange> = async data => {
  const borerStateId = data.borerStateId;
  // Temp state was not coded, mark as failed
  if (!approvedStatuses.includes(data.status) && borerStateId) {
    const db = RxdbManager.instance?.db;
    const borerOperatorChangeCollection =
      db?.collections[RxdbCollectionNameV2.BORER_OPERATOR_CHANGE_FEED];
    const tempStateDocsForBorerStateId = await borerOperatorChangeCollection
      ?.find({
        selector: {
          borerStateId,
        },
      })
      .exec();
    tempStateDocsForBorerStateId?.forEach(doc => doc.incrementalPatch({ failedSync: true }));
  }

  // we have to return an empty array here since we don't recieve the set of conflicts from our BE
  return [];
};
